import { PrimeReactProvider } from 'primereact/api';
import React, { useEffect, useRef, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { IdleTimerProvider } from 'react-idle-timer';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'primereact/resources/themes/lara-light-cyan/theme.css';
import loginApi from './api/services/login.service';
import CookieConsentModal from './components/AcceptAllCookies/Cookies';
import Notifications from './components/Generics/Notifications';
import LoaderComponent from './components/LoaderComponent';
import { ROUTES } from './constants';
import { ToastContextProvider } from './contexts/ToastContext';
import { useAuth } from './hooks/useAuth';
import {
    getUserPermissionCall,
    savingOrgId,
    savingUserId,
    savingOrgName,
    setFirstTimeUserValue,
    savingLoggedUserDetails,
    clearingPermissionData,
} from './redux/slice/getUserPermission/getUserPermissionSlice';
import {
    closeNotification,
    // openNotification,
} from './redux/slice/Notification/notifications';

import { clearUser } from './redux/slice/Scheduling/getServices';
import { getUserProfileDataCall } from './redux/slice/UserProfileData/userProfileDataSlice';
import RoutesComponent from './routes';
function App(): React.JSX.Element {
    const [, setCount] = useState(0);
    const [loading, setLoading] = useState(true);
    const { login } = useAuth();
    const url = window.location.href?.includes(
        // ROUTES.LoginPage ||
        ROUTES.OrganizationPage ||
            ROUTES.RegisterPage ||
            ROUTES.changePassword ||
            ROUTES.ForgotPassword ||
            ROUTES.sendEmail ||
            ROUTES.SignUp ||
            ROUTES.changePasswordWithLayout
    );
    const notifications = useSelector((state: any) => state.notifications);
    const userProfileData = useSelector(
        (state: any) => state.userProfileData.value
    );
    const dispatch = useDispatch<any>();
    const [isLoggedOut, setIsLoggedOut] = useState(false);
    const navigate = useNavigate();
    const { logout } = useAuth();
    const handleOnIdle = async (): Promise<void> => {
        if (!url) {
            setIsLoggedOut(true);
            const res = await loginApi.userLogout();
            logout().then(async () => {
                if (res) {
                    dispatch(clearingPermissionData());
                    dispatch(clearUser());
                    setTimeout(() => {
                        navigate(ROUTES.LoginPage);
                    }, 4000);
                    setCount(0);
                }
            });
        }
    };
    const handleOnActive = (): void => {
        if (isLoggedOut) {
            setIsLoggedOut(false);
        }
    };
    const access_token =
        sessionStorage?.access_token != undefined
            ? JSON.parse(sessionStorage?.access_token)
            : '';
    const userExist = useSelector(
        ({ getUserPermission }: any) => getUserPermission
    );
    const initializer = useRef(false);
    useEffect(() => {
        if (!initializer.current) {
            initializer.current = true;
            if (!access_token) {
                setLoading(false);
            } else if (
                access_token?.userId &&
                access_token?.orgId &&
                !userExist?.value?.data?.userId
            ) {
                dispatch(getUserProfileDataCall());
                dispatch(getUserPermissionCall()).then(() => {
                    setLoading(false);
                });
                dispatch(savingUserId(access_token?.userId));
                dispatch(savingOrgId(access_token?.orgId));
                dispatch(savingOrgName(access_token?.organizations));
                dispatch(
                    savingLoggedUserDetails({
                        username: access_token?.username,
                    })
                );
            } else if (
                userExist?.value?.data?.userId &&
                userProfileData?.data?.hasOwnProperty('isResetPassword')
            ) {
                dispatch(
                    setFirstTimeUserValue(
                        userProfileData?.data?.isResetPassword
                    )
                );
                // dispatch(SavingLoginData(access_token));
                login({
                    userId:
                        userExist?.value?.data?.userId || access_token?.userId,
                    orgId: userExist?.value?.data?.orgId || access_token?.orgId,
                }).then(() => {
                    setLoading(false);
                });
            }
        }
    }, []);
    const [isCookieModalOpen, setIsCookieModalOpen] = useState(false);
    useEffect(() => {
        const consent = localStorage.getItem('cookieYesConsent');
        if (consent !== 'true') {
            setIsCookieModalOpen(true);
        }
    }, []);
    const closeModal = (): void => {
        setIsCookieModalOpen(false);
    };
    return (
        <IdleTimerProvider
            timeout={1000 * 60 * 30} // 30 minutes
            onIdle={handleOnIdle}
            onActive={handleOnActive}
            debounce={500} // Throttle idle checks
        >
            <DndProvider backend={HTML5Backend}>
                <ToastContextProvider>
                    <PrimeReactProvider>
                        {notifications.isOpen ? (
                            <Notifications
                                title={notifications.title}
                                open={notifications.isOpen}
                                onClose={() => dispatch(closeNotification())}
                                success={notifications.success}
                            />
                        ) : null}
                        {loading ? <LoaderComponent /> : <RoutesComponent />}
                        {isCookieModalOpen && (
                            <CookieConsentModal
                                isOpen={isCookieModalOpen}
                                onClose={closeModal}
                            />
                        )}
                    </PrimeReactProvider>
                </ToastContextProvider>
            </DndProvider>
            {isLoggedOut && (
                <Notifications
                    title={'Session Expired'}
                    description={
                        'Session expired due to inactivity, Log in to continue where you left off!'
                    }
                    open={isLoggedOut}
                    onClose={() => setIsLoggedOut(false)}
                    success={notifications.success}
                    isSession={true}
                />
            )}
        </IdleTimerProvider>
    );
}
export default App;
